module.exports = __webpack_public_path__ + "14four/static/media/HealthIcon.3f630236.svg";